module.exports = __webpack_public_path__ + "img/end-automation_icon.a01bc491.svg";